// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 5326) return "static/chunks/5326-252180f63dcb4aac.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1022":"746731bd006242c3","1160":"28d2f374adc59d8e","2081":"fa45c53ea7573264","3681":"10906efc282673e3","6364":"56a97a1a28a933cf","7640":"d9ddbfd6da365139"}[chunkId] + ".js";
};